// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px;
  }
  
  .slider-mark {
    width: 20px;
    height: 20px;
    line-height: 20px;
    /* border: 2px solid #ddd; */
    /* border-radius: 50%; */
    text-align: center;
    color: #ddd;
    cursor: pointer;
    /* transition: color 0.3s, border-color 0.3s; */
  }
  
  .slider-mark.active {
    color: green;
    border-color: green;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Global/Atomics/atomics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,+CAA+C;EACjD;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB","sourcesContent":[".slider-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 20px;\n  }\n  \n  .slider-mark {\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    /* border: 2px solid #ddd; */\n    /* border-radius: 50%; */\n    text-align: center;\n    color: #ddd;\n    cursor: pointer;\n    /* transition: color 0.3s, border-color 0.3s; */\n  }\n  \n  .slider-mark.active {\n    color: green;\n    border-color: green;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
